import { render } from "./AlertsCard.vue?vue&type=template&id=79eb73e6&scoped=true"
import script from "./AlertsCard.vue?vue&type=script&lang=js"
export * from "./AlertsCard.vue?vue&type=script&lang=js"

import "./AlertsCard.vue?vue&type=style&index=0&id=79eb73e6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1709076162/src/harpia-offshore-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79eb73e6"]])

export default __exports__